/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { plugins } from '../../constants/plugins';
import type { EditorPlugins } from '../../types/EditorPlugins';
import { type ViewPlugin } from '../../types/ViewPlugin';

export type GroupedPlugins = Record<ViewPlugin['installPackage'], EditorPlugins>;

export function groupByInstallPackage( editorPlugins: EditorPlugins ): GroupedPlugins {
	const getPluginMetadata = ( name: string ) => plugins.find( plugin => plugin.className === name )!;

	return editorPlugins
		.map( getPluginMetadata )
		.reduce( ( result, plugin ) => {
			result[ plugin.installPackage ].push( plugin.className );

			return result;
		}, {
			ckeditor5: [] as EditorPlugins,
			'ckeditor5-premium-features': [] as EditorPlugins
		} );
}
